let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hnzJi")).then(() => parcelRequire('3mVC3'));